import { useUser } from "../context/UserContext";
import { updateLogoutTimeStamp } from "../services/userService";
import {
  AUDITRACEACTIONS,
  COMMONCONSTANTS,
  LOCALSTORAGENAME,
  USERINFO,  
} from "../data/constants";
import useApi from "./useApi";
import { useMsal } from "@azure/msal-react";
import { useSignalRConnections } from "../context/SignalRProvider";
import { logAuditTrace } from "../services/auditNavigationTraceService";
import { getCurrentESTTime } from "../utils/dateHelper";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { stopImpersonation } from "../redux/impersonationSlice";

export default function useLogout() {
  const { executeApi } = useApi();
  const { setUserId, userId } = useUser();
  const { instance } = useMsal();
  const { stopAllConnections } = useSignalRConnections();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const updateLogoutTime = async (objectName?: string) => {
    const sessionValue = localStorage.getItem(USERINFO.SESSIONVALUE);

    await executeApi(updateLogoutTimeStamp, sessionValue);

    logAuditTrace(
      {
        userId: userId,
        objectType: AUDITRACEACTIONS.Logout,
        objectId: userId,
        objectName: objectName ? objectName + userId : "Auto log out User Id " + userId,
        action: AUDITRACEACTIONS.Logout,
        navigationDateTime: getCurrentESTTime(),
      },
      null,
      true
    );
  };

  const logout = async (reason?: string, objectName?: string) => {
    await updateLogoutTime(objectName);

    await stopAllConnections();

    // Reset the in-memory impersonation flag too: localStorage.clear() removes the
    // impersonation keys but not the Redux state, so without this the flag would persist
    // after an inactivity timeout / logout that occurred during an active impersonation.
    dispatch(stopImpersonation());

    localStorage.clear();

    localStorage.setItem(
      LOCALSTORAGENAME.ISAZURELOGGEDIN,
      COMMONCONSTANTS.FALSE_VALUE
    );
    if(reason === COMMONCONSTANTS.INACTIVITY){
       localStorage.setItem(LOCALSTORAGENAME.INACTIVITY, "true");
    }
    localStorage.setItem(
      LOCALSTORAGENAME.LOGOUTEVENT,
      Date.now().toString()
    );

    setUserId(0);

    navigate("/signin", {
      state: { fromLogout: true, reason },
    });
  };

  const logoutWithAzure = async (objectName?: string) => {
    const isAzureLoggedin = localStorage.getItem(
      LOCALSTORAGENAME.ISAZURELOGGEDIN
    );

    if (isAzureLoggedin === COMMONCONSTANTS.TRUE_VALUE) {
      const account = instance.getActiveAccount();
      await instance.logoutPopup({ account });
    }

    await logout(undefined, objectName);
  };

  return { logout, logoutWithAzure };
}